import { createContext } from 'react'

const DiamondContext = createContext(null)
  
  export default DiamondContext